import {
  AuctionType,
  LotStatus,
  RegisteredForAuction,
} from '@bonhams1793/bonhams-typescript'
import getConfig from 'next/config'

import { ActionButtons } from '@nx/bidding-engine'
import { AMConfig } from '@nx/external/auction-mobility'
import { AuctionLot, LotCardItemProps, MaintenanceMode } from '@nx/global-types'
import { canAuctionBeRegisteredFor } from '@nx/helpers'

import {
  LotCardAMWrapper,
  LotClosingInStringComponent,
} from './LotCardAuctionMobility.styles'

const { publicRuntimeConfig } = getConfig()

export function LotCardAuctionMobility({
  showBidding,
  showActionButtons,
  lot,
  auctionType,
  lotClosingInString,
  hasHammerPrice,
  showLoginModal,
  showRegisterModal,
  showBidModal,
  isLoggedIn,
  registerLink,
  userHasAnAddress,
  userHasBids,
  userRegistrations,
  amActionsEnabled = true,
  hasTopMargin = true,
  isAddressInRegistrationModalEnabled,
}: LotCardAuctionMobilityProps) {
  const auctionReadyForRegistrationAndBidding = canAuctionBeRegisteredFor({
    auctionType: lot.auctionType,
    auctionStatus: lot.auctionStatus,
    rowId: lot.auctionAMId,
    biddingStatus: lot.biddingStatus,
    biddingEngine: 'AM',
  })

  const renderBidding =
    auctionReadyForRegistrationAndBidding &&
    showBidding &&
    lot.status.toUpperCase() !== LotStatus.withdrawn &&
    publicRuntimeConfig.MAINTENANCE_MODE !== MaintenanceMode.partial

  return renderBidding ? (
    <LotCardAMWrapper
      $hasHammerPrice={hasHammerPrice}
      $hasTopMargin={hasTopMargin}
    >
      <div
        id={`${AMConfig.wrapperPrefix}-${lot.lotAMId}`}
        lot-id={lot.lotAMId}
        className="am-data"
        data-testid="lot-card-am"
      >
        {auctionType === AuctionType.online && lotClosingInString ? (
          <LotClosingInStringComponent>
            {lotClosingInString}
          </LotClosingInStringComponent>
        ) : null}

        {auctionType === AuctionType.online && !lotClosingInString ? (
          <am-timer></am-timer>
        ) : null}

        <am-list-bid-status-label></am-list-bid-status-label>
        <am-list-lot-status-label></am-list-lot-status-label>
        {amActionsEnabled && <am-list-bid-box></am-list-bid-box>}
      </div>
    </LotCardAMWrapper>
  ) : showActionButtons ? (
    <ActionButtons
      showLoginModal={showLoginModal}
      showRegisterModal={showRegisterModal}
      showBidModal={showBidModal}
      registerLink={registerLink}
      isLoggedIn={isLoggedIn}
      userHasAnAddress={userHasAnAddress}
      userRegistrations={userRegistrations}
      userHasBids={userHasBids}
      lot={{
        auctionAMId: lot.auctionAMId,
        auctionId: String(lot.auctionId),
        auctionStatus: lot.auctionStatus,
        auctionType: lot.auctionType,
        biddableFrom: lot.biddableFrom,
        biddingStatus: lot.biddingStatus,
        isExhibition: lot.isExhibition,
        isPreview: lot.isPreview,
        isToBeSold: lot.isToBeSold,
        lotAMId: lot.lotAMId,
        biddingEngine: 'AM',
      }}
      isAddressInRegistrationModalEnabled={isAddressInRegistrationModalEnabled}
    />
  ) : null
}

export interface LotCardAuctionMobilityProps {
  showBidding: boolean
  showActionButtons: boolean
  showLoginModal: () => void
  showRegisterModal: () => void
  showBidModal: () => void
  isLoggedIn: boolean
  registerLink: string
  userHasAnAddress?: boolean
  userHasBids: boolean
  userRegistrations: RegisteredForAuction[]
  lot: LotCardItemProps
  auctionType: AuctionLot['auctionType']
  lotClosingInString?: string
  hasHammerPrice?: boolean
  amActionsEnabled?: boolean
  hasTopMargin?: boolean
  isAddressInRegistrationModalEnabled: boolean
}
